import { useLocation } from 'react-router'
import React from 'react'
import ApplicationConf from '../conf/ApplicationConf'
import { getAuthorization } from '../utils/ActionUtils'
import { getLogin } from '../utils/SettingUtils'
import moment from 'moment'

const sendStat = (action, user = getLogin()) => fetch(ApplicationConf.user.sendAquaparcStat(), {
    method: 'POST',
    body: JSON.stringify({ action, date: moment().valueOf(), user }),
    headers: getAuthorization(),
})

const AquaparcStatsSender = () => {
    const location = useLocation()
    const user = getLogin()
    React.useEffect(() => {
        const found = [
            // PIEZO
            ['/piezometry/exportOverview', 'PIEZO_BILAN-EXPORT'],
            ['/piezometry/integrationOverview', 'PIEZO_BILAN-INTEGRATION'],
            ['/piezometry/diagnostics', 'PIEZO_DIAGNOSTICS'],
            ['/piezometry/campaign', 'PIEZO_CAMPAGNES'],
            [/\/piezometry\/campaign\/\d+\/dashboard/g, 'PIEZO_CAMPAGNES_FICHE'],
            [/\/piezometry\/campaign\/\d+\/tracking/g, 'PIEZO_CAMPAGNES_MATERIEL'],
            [/\/piezometry\/campaign\/\d+\/materiel/g, 'PIEZO_CAMPAGNES_SUIVI'],
            ['/piezometry/export', 'PIEZO_EXPORT-DE-MASSE'],
            ['/piezometry/dashboard', 'PIEZO_LISTE'],
            ['/piezometry/piezometryOptions', 'PIEZO_OPTIONS'],
            ['/piezometry/graphic', 'PIEZO_SUPERPOSITION'],
            ['/piezometry/mapSituations', 'PIEZO_CARTES-SITUATION'],

            // PIEZO station
            [/\/station\/piezometry\/\d+\/event/g, 'PIEZO_EVENEMENTS'],
            [/\/station\/piezometry\/\d+\/materiel/g, 'PIEZO_MATERIEL'],
            [/\/station\/piezometry\/\d+\/iaeauModels/g, 'PIEZO_MODELES-PREVISIONNELS'],
            [/\/station\/piezometry\/\d+\/picture/g, 'PIEZO_PHOTOS_DOCUMENTS'],
            [/\/station\/piezometry\/\d+\/piezometricFollowUp/g, 'PIEZO_SUIVI-GRAPHIQUE'],
            [/\/station\/piezometry\/\d+\/piezoSuiviTable/g, 'PIEZO_SUIVI-TABLEAU'],
            [/\/station\/piezometry\/\d+\/validation/g, 'PIEZO_VALIDATION'],
            [/\/station\/piezometry\/\d+\/map/g, 'PIEZO_CARTOGRAPHIE'],
            [/\/station\/piezometry\/\d+\/description/g, 'PIEZO_DESCRIPTION'],
            [/\/station\/piezometry\/\d+\/dashboard/g, 'PIEZO_FICHE'],

            // HYDRO
            ['/hydrometry/campaign', 'HYDRO_CAMPAGNES'],
            [/\/hydrometry\/campaign\/\d+\/dashboard/g, 'HYDRO_CAMPAGNES_FICHE'],
            [/\/hydrometry\/campaign\/\d+\/tracking/g, 'HYDRO_CAMPAGNES_MATERIEL'],
            [/\/hydrometry\/campaign\/\d+\/materiel/g, 'HYDRO_CAMPAGNES_SUIVI'],
            ['/hydrometry/mapSituations', 'HYDRO_CARTES-SITUATION'],
            ['/hydrometry/export', 'HYDRO_EXPORT-DE-MASSE'],
            ['/hydrometry/integrationOverview', 'HYDRO_INTEGRATION'],
            ['/hydrometry/dashboard', 'HYDRO_LISTE'],
            ['/hydrometry/hydrometryOptions', 'HYDRO_OPTIONS'],
            ['/hydrometry/graphic', 'HYDRO_SUPERPOSITION'],

            // HYDRO station
            [/\/station\/hydrometry\/\d+\/map/g, 'HYDRO_CARTOGRAPHIE'],
            [/\/station\/hydrometry\/\d+\/description/g, 'HYDRO_DESCRIPTION'],
            [/\/station\/hydrometry\/\d+\/event/g, 'HYDRO_EVENEMENTS'],
            [/\/station\/hydrometry\/\d+\/dashboard/g, 'HYDRO_FICHE'],
            [/\/station\/hydrometry\/\d+\/materiel/g, 'HYDRO_MATERIEL'],
            [/\/station\/hydrometry\/\d+\/iaeauModels/g, 'HYDRO_MODELES-PREVISIONNELS'],
            [/\/station\/hydrometry\/\d+\/observations/g, 'HYDRO_OBSERVATIONS'],
            [/\/station\/hydrometry\/\d+\/picture/g, 'HYDRO_PHOTOS-DOCUMENTS'],
            [/\/station\/hydrometry\/\d+\/hydrometricFollowUp/g, 'HYDRO_SUIVI-GRAPHIQUE'],
            [/\/station\/hydrometry\/\d+\/hydroSuiviTable/g, 'HYDRO_SUIVI-TABLEAU'],
            [/\/station\/hydrometry\/\d+\/validationHydro/g, 'HYDRO_VALIDATION'],

            // PLUVIO
            ['/pluviometry/integrationOverview', 'PLUVIO_BILAN-INTEGRATION'],
            ['/pluviometry/campaign', 'PLUVIO_CAMPAGNES'],
            [/\/pluviometry\/campaign\/\d+\/dashboard/g, 'PLUVIO_CAMPAGNES_FICHE'],
            [/\/pluviometry\/campaign\/\d+\/tracking/g, 'PLUVIO_CAMPAGNES_MATERIEL'],
            [/\/pluviometry\/campaign\/\d+\/materiel/g, 'PLUVIO_CAMPAGNES_SUIVI'],
            ['/pluviometry/mapSituations', 'PLUVIO_CARTES-SITUATION'],
            ['/pluviometry/export', 'PLUVIO_EXPORT-DE-MASSE'],
            ['/pluviometry/dashboard', 'PLUVIO_LISTE'],
            ['/pluviometry/pluviometryOptions', 'PLUVIO_OPTIONS'],
            ['/pluviometry/graphic', 'PLUVIO_SUPERPOSITION'],

            // PLUVIO station
            [/\/station\/pluviometry\/\d+\/map/g, 'PLUVIO_CARTOGRAPHIE'],
            [/\/station\/pluviometry\/\d+\/description/g, 'PLUVIO_DESCRIPTION'],
            [/\/station\/pluviometry\/\d+\/event/g, 'PLUVIO_EVENEMENTS'],
            [/\/station\/pluviometry\/\d+\/dashboard/g, 'PLUVIO_FICHE'],
            [/\/station\/pluviometry\/\d+\/materiel/g, 'PLUVIO_MATERIEL'],
            [/\/station\/pluviometry\/\d+\/iaeauModels/g, 'PLUVIO_MODELES-PREVISIONNELS'],
            [/\/station\/pluviometry\/\d+\/picture/g, 'PLUVIO_PHOTOS-DOCUMENTS'],
            [/\/station\/pluviometry\/\d+\/pluviometricFollowUp/g, 'PLUVIO_SUIVI-GRAPHIQUE'],
            [/\/station\/pluviometry\/\d+\/validationPluvio/g, 'PLUVIO_VALIDATION'],

            // QUALITO
            ['/quality/conformityOverview', 'QUALITO_BILAN-CONFORMITE'],
            ['/quality/integrationOverview', 'QUALITO_BILAN-INTEGRATION'],
            ['/quality/campaign', 'QUALITO_CAMPAGNES'],
            [/\/quality\/campaign\/\d+\/dashboard/g, 'QUALITO_CAMPAGNES_FICHE'],
            [/\/quality\/campaign\/\d+\/tracking/g, 'QUALITO_CAMPAGNES_MATERIEL'],
            [/\/quality\/campaign\/\d+\/materiel/g, 'QUALITO_CAMPAGNES_SUIVI'],
            [/\/quality\/campaign\/\d+\/file/g, 'QUALITO_CAMPAGNES_FICHIERS'],
            ['/quality/export', 'QUALITO_EXPORT-DE-MASSE'],
            ['/quality/dashboard', 'QUALITO_LISTE'],
            ['/quality/qualityOptions/generalOptions', 'QUALITO_OPTIONS'],
            ['/quality/qualityOptions/indicators', 'QUALITO_OPTIONS_INDICATEURS-QUALITE'],
            ['/quality/qualityOptions/selection', 'QUALITO_OPTIONS_SELECTIONS'],
            ['/quality/qualityOptions/threshold', 'QUALITO_OPTIONS_SEUILS'],
            ['/quality/research', 'QUALITO_RECHERCHE'],
            ['/quality/graphic', 'QUALITO_SUPERPOSITION'],

            // QUALITO station
            [/\/station\/quality\/\d+\/hydrobioMonitoring/g, 'QUALITO-SUIVI-HYDROBIO'],
            [/\/station\/quality\/\d+\/map/g, 'QUALITO_CARTOGRAPHIE'],
            [/\/station\/quality\/\d+\/description/g, 'QUALITO_DESCRIPTION'],
            [/\/station\/quality\/\d+\/qualityStates/g, 'QUALITO_ETATS'],
            [/\/station\/quality\/\d+\/event/g, 'QUALITO_EVENEMENTS'],
            [/\/station\/quality\/\d+\/dashboard/g, 'QUALITO_FICHE'],
            [/\/station\/quality\/\d+\/materiel/g, 'QUALITO_MATERIEL'],
            [/\/station\/quality\/\d+\/hydrobioOperation/g, 'QUALITO_OPERATIONS-HYDROBIO'],
            [/\/station\/quality\/\d+\/hydrobioOperation\/\d+/g, 'QUALITO_OPERATIONS-HYDROBIO_OPERATION'],
            [/\/station\/quality\/\d+\/operation/g, 'QUALITO_OPERATIONS-PC'],
            [/\/station\/quality\/\d+\/operation\/\d+/g, 'QUALITO_OPERATIONS-PC_OPERATION'],
            [/\/station\/quality\/\d+\/picture/g, 'QUALITO_PHOTOS-DOCUMENTS'],
            [/\/station\/quality\/\d+\/suiviPC/g, 'QUALITO_SUIVI-PC'],

            // PGSSE
            [/\/pgsse\/phase1/g, 'PGSSE_PHASE1'],
            [/\/pgsse\/phase1\/\d+/g, 'PGSSE_PHASE1_DIAGNOSTIC'],
            [/\/pgsse\/phase1\/\d+\/campaign\/d+/g, 'PGSSE_PHASE1_DIAGNOSTIC_CAMPAGNES'],
            [/\/pgsse\/phase1\/\d+\/campaign\/d+\/d+/g, 'PGSSE_PHASE1_DIAGNOSTIC_CAMPAGNES_FORM'],
            [/\/pgsse\/phase1\/\d+\/d+/g, 'PGSSE_PHASE1_DIAGNOSTIC_FORM'],
            [/\/pgsse\/phase2/g, 'PGSSE_PHASE2'],
            [/\/pgsse\/phase2\/\d+/g, 'PGSSE_PHASE2_DANGERS'],
            [/\/pgsse\/phase3/g, 'PGSSE_PHASE3'],
            [/\/pgsse\/phase3\/\d+/g, 'PGSSE_PHASE3_ACTIONS'],
            [/\/pgsse\/phase4/g, 'PGSSE_PHASE4'],
            [/\/pgsse\/phase4\/\d+/g, 'PGSSE_PHASE4_DIAGNOSTIC'],
        ].find(tab => {
            const path = tab[0]
            return (typeof (path) === 'string' && location.pathname === path) || (typeof (path) === 'object' && location.pathname.match(path))
        })
        if (found) {
            sendStat(found[1], user)
        }
    }, [location])
    return null
}

export { AquaparcStatsSender, sendStat }